import { useMemo } from 'react'
import { UserInfoHS } from 'src/commons/store/UserStore'

/** 结果是false则代表需要绑定手机号 */
const useIsBindMobile = () => {
  const UserInfo = UserInfoHS.SuccessResult
  const isBindMobile = useMemo(() => {
    const patt = /^11|^12/
    if (UserInfo) {
      const isFictitious = patt.test(UserInfo.mobile)
      return !isFictitious || !UserInfo.enforceBindMobile
    } else {
      return false
    }
  }, [UserInfo])
  return {
    isBindMobile,
  }
}

export default useIsBindMobile
